import { render } from "./PHeaderUserInfo.vue?vue&type=template&id=03d6f82a&scoped=true"
import script from "./PHeaderUserInfo.vue?vue&type=script&lang=js"
export * from "./PHeaderUserInfo.vue?vue&type=script&lang=js"

import "./PHeaderUserInfo.vue?vue&type=style&index=0&id=03d6f82a&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d6f82a"]])

export default __exports__